import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../utilities/modalHOC';
import { getPermissions } from '../Login/selectors';
import { getPagination } from '../Rates/selectors';
import {
  createNotification,
  deleteNotification,
  editNotification,
  getAllRates,
  getNotificationByRate,
  setRate,
} from './actionsSagas';
import messageCenter from './messageCenter';
import {
  getAllRatesSelectors,
  getNotificationsSelectors,
  getRateSelector,
  loadNoticationsSelectors,
} from './selectors';

const mapStateToProps = (state) => ({
  ratesPagination: getPagination(state),
  rates: getAllRatesSelectors(state),
  rate: getRateSelector(state),
  loadNotifications: loadNoticationsSelectors(state),
  notifications: getNotificationsSelectors(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAllRates: () => dispatch(getAllRates()),
  setRate: (rate) => dispatch(setRate(rate)),
  createNotification: (notification) =>
    dispatch(createNotification(notification)),
  getNotifications: (rateId) => dispatch(getNotificationByRate(rateId)),
  deleteNotification: (notificationId) =>
    dispatch(deleteNotification(notificationId)),
  editNotification: (notificationId, notificationValue) =>
    dispatch(editNotification(notificationId, notificationValue)),
});

export default addAbilityToOpenModal(
  connect(mapStateToProps, mapDispatchToProps)(messageCenter),
);
